import { type JSX, type PropsWithChildren } from 'react'
import { cn } from '@ttab/elephant-ui/utils'
import { ValidationIcon } from './ValidationIcon'

/**
 * The red triangle a form puts on a field that keeps it from being submitted,
 * pinned to the field's top right corner. Only the look - when to show it is
 * the caller's.
 */
export const ValidationCue = ({ show, className, children }: PropsWithChildren<{
  show: boolean
  className?: string
}>): JSX.Element => (
  <div className={cn('relative', className)}>
    {show && <ValidationIcon className='absolute -top-1 right-0 h-2 w-2 z-10' />}
    {children}
  </div>
)
